import React, { useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Button from "react-bootstrap/Button";
import { Route, Switch } from "react-router";
import { Link } from "react-router-dom";
import axios from "axios";
import PresetMessagesComponent from "../components/SendMessages/PresetMessages";
import SendMessages from "../components/SendMessages";
import Axios from "axios";
import afterLoginApiAxios from "../Util/API Calls/afterLogin";
import DownloadReport from "../components/DownloadReport/DownloadReport";
import { LOCALSTORAGEKEY } from "../Util/Helper/localStorageUtils";
import { C2CConsole } from "../Util/Helper/C2CConsole";

const ComposeMessageComponent = () => <h3>ComposeMessageComponent Messages</h3>;
const SentMessagesComponent = () => <h3>SentMessagesComponent Messages</h3>;

const MessagesContainer = (props) => {
  const presets = {};

  const [sentMessages, setSentMessages] = useState([]);

  //   useEffect(() => {
  //     axios.post("/user/12345", {
  //       doctor_id: "new name",
  //       "authorizer-principal-id": {
  //         user_type: 1,
  //       },
  //     });
  //   }, []);
  const [presetTemplates, setPresetTemplates] = useState([]);
  useEffect(() => {
    initialApiCall();
  }, [window.localStorage]);

  const initialApiCall = () => {
    let token;
    let doctor_id;
    try {
      token = window.localStorage.getItem("id_token");
      doctor_id = window.localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
    } catch (error) {}

    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-care-templates",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        "authorizer-principal-id": {
          user_type: "1",
        },
        template_id: "ccda8fcb-41fa-4c27-a95a-221d51d26c3e",
      },
    })
      .then(function (response) {
        setPresetTemplates(response.data.care_templates);
      })
      .catch(function (error) {
        C2CConsole.log(error);
      });
    afterLoginApiAxios({
      method: "post",
      url: "/doctor/get-sent-msgs",
      headers: {
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: token,
      },
      data: {
        doctor_id: doctor_id,
        appointment_date: "",
        "authorizer-principal-id": {
          user_type: "1",
        },
      },
    })
      .then(function (response) {
        setSentMessages(response.data.sent_messages);
      })
      .catch(function (error) {
        C2CConsole.log(error);
      });
  };

  return (
    <div style={{ minHeight: "80vh" }} className="transaction-conatiner-div">
      <Row>
        <Col md={7} sm={12}>
          <SendMessages
            presetTemplates={presetTemplates}
            sentMessages={sentMessages}
            initialApiCall={initialApiCall}
          />
        </Col>
        <Col md={5} sm={12}>
          <PresetMessagesComponent presetTemplates={presetTemplates}>
            {props.children}
          </PresetMessagesComponent>
        </Col>
      </Row>
      <DownloadReport />
    </div>
  );
};

export default MessagesContainer;
